import { render, staticRenderFns } from "./InteractionItem.vue?vue&type=template&id=2705f3b2&scoped=true&"
import script from "./InteractionItem.vue?vue&type=script&lang=js&"
export * from "./InteractionItem.vue?vue&type=script&lang=js&"
import style0 from "./InteractionItem.vue?vue&type=style&index=0&id=2705f3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2705f3b2",
  null
  
)

component.options.__file = "InteractionItem.vue"
export default component.exports